import { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_ALERT_VARIANT = {
  Info: "info",
  Success: "success",
  Warning: "warning",
  Error: "error",
} as const;

export type DSAlertVariant = ObjectValues<typeof DS_ALERT_VARIANT>;
